import React from 'react';
import featureimage from '../images/Frame 19.png';
import {Link} from 'react-scroll';

function Privacy() {
    return (
        <div id='features'>
           {/* <div className='features-model'> */}
                {/* <img src={featureimage} alt='feature-image' /> */}
                {/* <img src='https://newocean.in/wp-content/uploads/2019/11/privacy-policy.jpg' alt='feature-image' /> */}
           {/* </div> */}
           <div className='features-text'>
               <h2>END-USER LICENSE AGREEMENT Snakes LTD</h2>
               <h3>
               IMPORTANT - READ CAREFULLY: This End-User License Agreement ("EULA") is a legal agreement between you and mlThings.ai also known as Zvi Yamin LTD("Company") for the Snakes LTD software product ("Software"). By installing, copying, or otherwise using the Software, you agree to be bound by the terms of this EULA. If you do not agree to the terms of this EULA, do not install or use the Software.
                    </h3>
               <p>
               1. LICENSE GRANT<br/>
                
               <ul>
<li>
Company grants you a non-exclusive, non-transferable license to install and use the Software on a single device, unless otherwise specified in the Software documentation. You may not make copies of the Software or any portion thereof, except for the purpose of making a single archival copy.
</li>

</ul>
2. PROPRIETARY RIGHTS
<ul>
The Software is protected by copyright laws and international copyright treaties, as well as other intellectual property laws and treaties. The Software is licensed, not sold.
 <br/>

</ul>
3. RESTRICTIONS
<ul>
You may not reverse engineer, decompile, or disassemble the Software, except to the extent that such activity is expressly permitted by applicable law. You may not rent, lease, or lend the Software. You may not use the Software for any commercial purpose. However, you are allowed to share and broadcast gameplay footage of the Software on platforms such as Twitch and YouTube, as long as you give credit to the Company and include a link to the official website or store page for the Software.
</ul>
4. TERMINATION
<ul>
This EULA will terminate automatically if you fail to comply with any of the terms and conditions of this EULA. In such event, you must immediately delete all copies of the Software and all of its component parts.
</ul>
5. DISCLAIMER OF WARRANTIES
<ul>
The Software is provided "AS IS" without warranty of any kind, either express or implied, including, but not limited to, the implied warranties of merchantability and fitness for a particular purpose. Company does not warrant that the Software will meet your requirements or that the operation of the Software will be uninterrupted or error-free.
</ul>
6. LIMITATION OF LIABILITY
<ul>
In no event shall Company be liable for any damages (including, without limitation, lost profits, business interruption, or lost information) rising out of 'Authorized Users' use of or inability to use the Software, even if Company has been advised of the possibility of such damages. In no event will Company's liability for any claim, whether in contract, tort, or any other theory of liability, exceed the license fee paid by you, if any.
</ul>
7. GOVERNING LAW
<ul>
This EULA shall be governed by and construed in accordance with the laws of the state of Israel.
</ul>
8. UPDATES AND UPGRADES
<ul>
The Company reserves the right to release updates and upgrades to the Software at any time and without notice. These updates and upgrades may be provided to you at no additional cost or may be subject to an additional fee. By installing, copying or otherwise using any update or upgrade to the Software, you agree to be bound by the terms of this EULA with respect to such update or upgrade. 
</ul>
9. ENTIRE AGREEMENT
<ul>
This EULA constitutes the entire agreement between you and Company and supersedes all prior agreements or understandings, whether oral or written.
</ul>

               </p>
               <a href="https://zviyamin.com/">
               <button onclick="/" type="button">Back To Home Page</button>
               <br/><br/>
               </a>
           </div>
        </div>
    )
}

export default Privacy;